import { addDays, addWeeks, differenceInDays, format, getDay, getWeek, startOfWeek, subDays } from "date-fns";
import React, { useEffect, useState } from "react";
import { checkEmailInValid, getFirebaseDocs, stripeKey } from "../common";
import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { db } from "../firebase-config";
import ModalComp from "../components/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "../redux/userReducer";
import Cart from '../assets/Cart.png'
import axios from 'axios'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { toast } from "react-toastify";
import Holiday from '../assets/HolidayProgram.png'
import UniformImg from '../assets/Uniform.jpg'
import CheckoutForm from "../components/CheckoutForm";
import BookingHeader from '../assets/BookingHeader.jpg'
import BookingHolidaySnaps from '../assets/BookingHolidaySnaps.jpg'
import Watermark from '../assets/Watermark.png'
import Input from "../components/Input";
import Dropdown from "../components/Dropdown";
import CalendarNew from "../components/CalendarNew";
import { useNavigate } from "react-router-dom";
import { margin } from "@mui/system";

const stripePromise = loadStripe(stripeKey);

const BookingHoliday = () => {

    const [clientSecret, setClientSecret] = useState("");
    const [sum, setSum] = useState("");
    const [loading, setLoading] = useState(false);

    const [showBookPopup, setShowBookPopup] = useState(false)
    const [currentBooking, setCurrentBooking] = useState(false)

    const [parentName, setParentName] = useState('')
    const [childName, setChildName] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [postcode, setPostCode] = useState('')

    const existingCartBookings = useSelector(state => state.user.bookings)
    const [discount, setDiscount] = useState(0)
    const [discountCode, setDiscountCode] = useState('')

    const [showCart, setShowCart] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        // generateMoreCodes()
    }, [])

    // const generateMoreCodes = async () => {

    //     const generateCode = (length = 8) => {
    //         const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    //         return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
    //     };

    //     const createHolidayCodes = async () => {
    //         for (let i = 0; i < 18; i++) {
    //             const code = generateCode(10); // e.g. 10-char code
    //             const docRef = doc(db, "booking-holiday-codes", code);

    //             await setDoc(docRef, {
    //                 created: new Date().toISOString(),
    //                 used: false // you can add extra fields if needed
    //             });

    //             console.log(`✅ Created code: ${code}`);
    //         }
    //     };

    //     createHolidayCodes()
    //         .then(() => console.log("🎉 All 18 coupon codes generated!"))
    //         .catch((err) => console.error("Error creating codes:", err));
    // }

    const holidaySessions = [
        { title: '2-5 Year Old', price: 40, name: 'AFL Grand Final Special', desc: '25 Sep 2025', startDate: new Date('2025-09-25').toISOString(), startDateString: '25 Sep 2025', timeBlock: '9:15AM - 10:15AM' },
        { title: '5-7 Year Old', price: 55, name: 'AFL Grand Final Special', desc: '25 Sep 2025', startDate: new Date('2025-09-25').toISOString(), startDateString: '25 Sep 2025', timeBlock: '10:30AM - 12:00PM' },
    ]

    useEffect(() => {
        if (currentBooking) {
            dispatch(setBookings([...existingCartBookings, currentBooking]))
            setCurrentBooking()
            setShowCart(true)
            setShowBookPopup(false)
            toast.success('Session added to cart', { position: 'top-center', style: { marginTop: '20px' } })
        }
    }, [currentBooking])

    const handleCreatePaymentIntent = async () => {

        // Check if email used in past free trial bookings.

        setLoading(true)

        const sumLoc = existingCartBookings.map(r => r.price).reduce((partialSum, a) => partialSum + a, 0)
        const doc = await addDoc(collection(db, 'bookings-holiday-temp'), {
            items: existingCartBookings,
            childName,
            parentName,
            email,
            phoneNumber,
            postcode,
            sum: sumLoc - discount,
            discountCode: discount ? discountCode : ''
        })

        try {

            const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/createPaymentIntentHoliday', { id: doc.id },)
            // const resp = await axios.post('http://127.0.0.1:5001/mini-monstars-au/australia-southeast2/createPaymentIntentHoliday', { id: doc.id },)

            console.log(resp.data)
            if (resp.data.err) {
                toast.error('Unknown error ocurred. Try again.')
                setLoading(false)
                return
            }
            if (resp.data.data.bookingCompletedId) {
                const bookingCompletedId = resp.data.data.bookingCompletedId
                navigate(`/orderComplete?tempBookingId=${bookingCompletedId}`)
            } else {
                setClientSecret(resp.data.data.clientSecret)
                setSum(sumLoc - discount)
            }
        } catch (e) {
            console.error('e', e)
            toast.error('Error occurred')
        }

        setLoading(false)
    }


    const checkIfCodeValid = async () => {
        const total = existingCartBookings.map(r => r.price).reduce((partialSum, a) => partialSum + a, 0)
        if (['MONSTAR10OFF', 'MONSTAR20OFF'].includes(discountCode)) {
            setDiscount(total * (discountCode === 'MONSTAR10OFF' ? 0.1 : 0.2))
            return
        }

        const codeData = await (await getDoc(doc(db, 'booking-holiday-codes', discountCode))).data()
        if (codeData && !codeData.used) {
            setDiscount(total >= 55 ? 55 : 40)
            toast.success('Discount code applied!!')
        } else {
            toast.error('Discount code invalid!!')
            setDiscount(0)
            setDiscountCode('')
        }
    }

    if (clientSecret) {
        const appearance = {
            theme: 'stripe',
        };
        // Enable the skeleton loader UI for optimal loading.
        const loader = 'auto';

        return (<div style={{ width: '100%', height: '100vh', overflow: 'scroll', backgroundColor: '#fed82b', }}>
            <img src={BookingHeader} style={{ width: '100%' }} />

            <Elements options={{ clientSecret, appearance, loader, }} stripe={stripePromise}>
                <CheckoutForm amount={sum} setClientSecret={setClientSecret} />
            </Elements>
        </div>)
    }

    return <div style={{ backgroundColor: '#fed82b', height: '100vh', overflow: 'scroll', position: 'relative' }}>

        <h2 style={{ textAlign: 'center' }}>This page has been deactivated...</h2>
    </div>

    return <div style={{ backgroundColor: '#fed82b', height: '100vh', overflow: 'scroll', position: 'relative' }}>

        <img src={BookingHeader} style={{ width: '100%' }} />
        <img src={Holiday} style={{ width: '100%', maxHeight: '500px', objectFit: 'contain' }} />

        <ModalComp showModal={!!showBookPopup} setShowModal={setShowBookPopup} customStyle={{ content: { height: '300px', width: '300px', margin: 'auto' } }}>
            <h2>{showBookPopup.name}</h2>
            <h3> {showBookPopup.title}</h3>
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'childName'} value={childName} setValue={setChildName} label={'Child Name'} />

            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                <button style={{ maxWidth: '200px' }} disabled={!childName} onClick={() => { setCurrentBooking({ ...showBookPopup, childName, }) }}> Continue</button>
                <button className="textButton" style={{ marginTop: '30px', width: '120px' }} onClick={() => setShowBookPopup(false)}> Cancel</button>
            </div>
        </ModalComp>

        {!showCart &&
            <>
                <h3 style={{ textAlign: 'center', color: 'red', marginBottom: '-10px' }}>BOOK HERE!!</h3>
                <div style={{ margin: '10px', display: 'flex', justifyContent: 'center', gap: '20px', position: 'relative', zIndex: 10 }}>
                    <button style={{ padding: '10px', backgroundColor: '#0096ed' }} onClick={() => { setShowBookPopup(holidaySessions[0]); }}>Book for 2-5 Year Old</button>
                    <button style={{ padding: '10px', backgroundColor: 'red' }} onClick={() => { setShowBookPopup(holidaySessions[1]); }}>Book for 5 -7 Year Old</button>
                </div>
                <section
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "28px 16px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "820px",
                            background: "#ffffff",
                            borderRadius: "20px",
                            boxShadow:
                                "0 10px 25px rgba(2,6,23,0.15), inset 0 1px 0 rgba(255,255,255,0.6)",
                            padding: "28px",
                            lineHeight: 1.55,
                        }}
                    >
                        {/* Title */}
                        <div
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "8px 12px",
                                background:
                                    "linear-gradient(90deg, rgba(255,215,0,0.2) 0%, rgba(255,165,0,0.2) 100%)",
                                borderRadius: "999px",
                                fontWeight: 700,
                                letterSpacing: "0.4px",
                                color: "#111827",
                                marginBottom: "14px",
                            }}
                        >
                            <span style={{ fontSize: "22px" }}>🏉</span>
                            <span style={{ fontSize: "14px", textTransform: "uppercase" }}>
                                MINI MONSTARS AFL GRAND FINAL SPECIAL
                            </span>
                            <span style={{ fontSize: "22px" }}>🏆</span>
                        </div>

                        {/* Headline */}
                        <h1
                            style={{
                                fontSize: "28px",
                                margin: "0 0 8px",
                                color: "#0f172a",
                                letterSpacing: "-0.3px",
                            }}
                        >
                            It’s Grand Final time – and we’re bringing the footy fun to Mini Monstars!
                        </h1>

                        <p style={{ margin: "0 0 18px", color: "#334155", fontSize: "16px" }}>
                            Join us for a special celebration where kids will:
                        </p>

                        {/* AFL Skills List */}
                        <ul
                            style={{
                                listStyle: "none",
                                padding: 0,
                                margin: "0 0 18px",
                                display: "grid",
                                gridTemplateColumns: "1fr",
                                gap: "10px",
                            }}
                        >
                            <li
                                style={{
                                    background: "#f8fafc",
                                    borderRadius: "12px",
                                    padding: "12px 14px",
                                    border: "1px solid #e5e7eb",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span style={{ fontSize: "20px" }}>🏉</span>
                                <span style={{ color: "#1f2937" }}>
                                    Learn and play exciting AFL football skills
                                </span>
                            </li>
                            <li
                                style={{
                                    background: "#f8fafc",
                                    borderRadius: "12px",
                                    padding: "12px 14px",
                                    border: "1px solid #e5e7eb",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span style={{ fontSize: "20px" }}>🥅</span>
                                <span style={{ color: "#1f2937" }}>
                                    Kick, handball, and practice movement drills just like their favourite players
                                </span>
                            </li>
                            <li
                                style={{
                                    background: "#f8fafc",
                                    borderRadius: "12px",
                                    padding: "12px 14px",
                                    border: "1px solid #e5e7eb",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span style={{ fontSize: "20px" }}>🎉</span>
                                <span style={{ color: "#1f2937" }}>
                                    Celebrate the AFL spirit in a fun, safe, and active environment
                                </span>
                            </li>
                        </ul>

                        <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "18px 0" }} />

                        <p style={{ margin: "0 0 12px", color: "#334155", fontSize: "16px" }}>
                            But that’s not all! Alongside all the footy action, we’ll also enjoy:
                        </p>

                        {/* Extras Grid */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                                gap: "12px",
                            }}
                        >
                            <div
                                style={{
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "14px",
                                    padding: "14px",
                                    background:
                                        "linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)",
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <span style={{ fontSize: "22px" }}>🎵</span>
                                    <strong style={{ color: "#0f172a" }}>Music</strong>
                                </div>
                                <p style={{ margin: "8px 0 0", color: "#475569" }}>
                                    Moving and grooving to the beat
                                </p>
                            </div>

                            <div
                                style={{
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "14px",
                                    padding: "14px",
                                    background:
                                        "linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)",
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <span style={{ fontSize: "22px" }}>🤸</span>
                                    <strong style={{ color: "#0f172a" }}>Gymnastics</strong>
                                </div>
                                <p style={{ margin: "8px 0 0", color: "#475569" }}>
                                    Building strength, balance, and coordination
                                </p>
                            </div>

                            <div
                                style={{
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "14px",
                                    padding: "14px",
                                    background:
                                        "linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)",
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <span style={{ fontSize: "22px" }}>🧘</span>
                                    <strong style={{ color: "#0f172a" }}>Yoga</strong>
                                </div>
                                <p style={{ margin: "8px 0 0", color: "#475569" }}>
                                    Stretching, relaxing, and having mindful fun
                                </p>
                            </div>
                        </div>

                        {/* Closing blurb */}
                        <div
                            style={{
                                marginTop: "22px",
                                padding: "16px",
                                borderRadius: "14px",
                                background:
                                    "linear-gradient(90deg, rgba(34,197,94,0.08) 0%, rgba(59,130,246,0.08) 100%)",
                                border: "1px solid #e2e8f0",
                                color: "#1f2937",
                            }}
                        >
                            This action-packed session is the perfect way for kids to celebrate the AFL Grand Final
                            while exploring movement, teamwork, and Monstar energy!
                        </div>
                    </div>
                </section>

                <img src={BookingHolidaySnaps} style={{ width: '100%', maxHeight: '600px', objectFit: 'contain' }} />
            </>
        }
        {loading && <p style={{ margin: 'auto', textAlign: 'center' }}>Loading... Please wait.</p>}
        <img src={Watermark} className='watermark' style={{ zIndex: 0, display: 'flex', position: 'absolute', maxHeight: '600px', width: '100%', height: '100%', objectFit: 'contain', opacity: 0.2 }} />

        {showCart && <div style={{ padding: '10px', maxWidth: '450px', width: 'calc(100% - 20px)', position: 'relative', margin: 'auto', zIndex: 10, display: 'flex', flexDirection: 'column' }}>
            <h2>Your Details</h2>
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'parentName'} value={parentName} setValue={setParentName} label={'Parent Name'} />
            <div style={{ marginBottom: '-15px' }} />
            <Input bold type={'email'} errorMessage={''} errors={[]} name={'email'} value={email} setValue={setEmail} label={'Email'} />
            <div style={{ marginBottom: '-15px' }} />
            <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'phoneNumber'} value={phoneNumber} setValue={v => (!v || (v && v.match(/\d/))) && setPhoneNumber(v)} label={'Phone Number'} />
            <div style={{ marginBottom: '-15px' }} />
            <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'postcode'} value={postcode} setValue={setPostCode} label={'Post Code'} />

            <h2>Cart</h2>

            <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '20px' }}>
                <div style={{ fontWeight: 'bold', width: 'calc(100% - 100px)' }}>
                    Name
                </div>
                <div style={{ fontWeight: 'bold', width: '150px' }}>
                    Time
                </div>
                <div style={{ fontWeight: 'bold' }}>
                    Total
                </div>
            </div>


            {
                existingCartBookings.map((booking, index) => <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', paddingBottom: '10px', borderBottom: '2px solid grey' }}>
                    <div style={{ width: 'calc(100% - 100px)' }}>
                        <p style={{ margin: 0 }}>{booking.name}</p>
                        <p style={{ margin: 0 }}>{booking.title} {booking.desc}</p>
                        <p style={{ margin: 0 }}>{booking.childName}</p>
                        <p style={{ fontWeight: 'bold', color: 'red' }} className="hover" onClick={() => { dispatch(setBookings(existingCartBookings.filter((r, idx) => idx !== index))) }}>Remove</p>
                    </div>


                    <p style={{ width: '150px' }}>{booking.timeBlock}</p>

                    <p style={{ fontWeight: 'bold' }}>${booking.price}</p>
                </div>)


            }

            {/* Show discount */}
            {discount ? <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', paddingBottom: '10px', borderBottom: '2px solid grey' }}>
                <div style={{ width: 'calc(100% - 100px)' }}>
                    <p style={{ margin: 0 }}>Discount</p>
                </div>

                <p style={{ width: '150px' }}>-</p>

                <p style={{ fontWeight: 'bold' }}>-${discount}</p>
            </div> : <></>}


            {existingCartBookings.length === 0 && <p style={{ textAlign: 'center' }}>No items in your cart.</p>}
            <hr style={{ marginTop: '10px' }} />

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: 'calc(100% - 100px)' }}>
                    <p style={{ margin: 0, fontWeight: 'bold' }}>Total</p>
                </div>
                <p style={{ width: '100px', margin: 0 }}>-</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>${existingCartBookings.map(r => r.price).reduce((partialSum, a) => partialSum + a, 0) - discount}</p>

            </div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'discountCode'} value={discountCode} setValue={setDiscountCode} label={'Discount Code'} />
                <button disabled={!discountCode} style={{ height: '50px', marginBottom: '10px' }} onClick={checkIfCodeValid}>Apply Discount</button>
            </div>

            {loading && <p style={{ margin: 'auto', textAlign: 'center' }}>Loading... Please wait.</p>}
            <section
                style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "24px 16px",
                }}>
                <div
                    style={{
                        width: "100%",
                        maxWidth: "720px",
                        borderRadius: "12px",
                        background: 'white',
                        border: "1px solid #e5e7eb",
                        padding: "24px",
                        lineHeight: 1.6,
                        fontSize: "15px",
                        color: "#374151",
                    }}
                >
                    {/* Heading */}


                    {/* Note */}
                    <div
                        style={{
                            background: "#f9fafc",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            padding: "12px 14px",
                            marginBottom: "18px",
                            fontSize: "14px",
                            color: "#475569",
                        }}>
                        <p style={{ margin: 0 }}>
                            📸 <strong>Please Note:</strong> Photos and video content may be taken on
                            the day. By attending this event, you consent for your child to be filmed
                            or photographed, with the possibility of this content being used for Mini
                            Monstars promotional purposes (e.g., social media, website, and marketing
                            materials).
                        </p>
                    </div>

                    {/* Address */}
                    <p style={{ margin: "0 0 6px", fontWeight: 600, color: "#111827" }}>
                        📍 ADDRESS:
                    </p>
                    <p style={{ margin: 0 }}>
                        CASEY STADIUM <br />
                        Building 65, 04 Terry Vickerman <br />
                        65 Berwick-Cranbourne Rd <br />
                        Cranbourne East VIC 3977
                    </p>
                </div>
            </section>

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button disabled={loading} className="secondary" style={{ marginLeft: 0, marginRight: '20px' }} onClick={() => setShowCart(false)}>Back</button>
                <button disabled={!parentName || !email || !phoneNumber || !postcode || checkEmailInValid(email) || existingCartBookings.length === 0 || loading} onClick={handleCreatePaymentIntent}>Continue</button>
            </div>


        </div>
        }

    </div >
}

export default BookingHoliday